<template>
  <div class="RefundOrderCardContainer shadow mb18 brd8">
    <nut-row class="leftCenter wd100 ft12">
      <nut-tag class="mr6" type="success">{{ data.saleRecord.paidSeqId }}</nut-tag>
      <img :src="data.saleRecord.buyerAvatar" class="sqr20 brd10">
      <nut-ellipsis :content="`${data.saleRecord.buyerName}(from: ${data.saleRecord.agentName})`" :rows="1"
                    class="ft12 mr6 ml6"/>
      <!--      <span class="ml6">{{ data.saleRecord.buyerName }}</span>-->
      <!--      <span class="ml12 mr6" v-if="data.saleRecord.agentName">(from: {{ data.saleRecord.agentName }})</span>-->
      <img src="https://cdn.waityou.online/0fc3746d-6a91-8694-cc2d-f28792c31520.svg"
           v-if="data.saleRecord.payMethod == 'WECHAT_JSAPI'" class="sqr16">
      <img src="https://cdn.waityou.online/34c842cc-48ce-6194-8319-122794fd35f3.svg"
           v-if="data.saleRecord.payMethod == 'ALIPAY_NATIVE'" class="sqr16">
      <img src="https://cdn.waityou.online/1945c1ba-228f-99c3-3c2d-4f051b4f5990.svg"
           v-if="data.saleRecord.payMethod == 'BALANCE_PAY'" class="sqr16">
    </nut-row>
    <nut-row class="mt8" @click="$router.push('/sale/agent/order/detail/'+data.saleRecord.id)">
      <nut-col :span="4" class="leftCenter">
        <img :src="data.saleRecord.goodImage"
             class="sqr40 brd8"/>
      </nut-col>
      <nut-col :span="20" class="colFlex">
        <span class="ft18 boldFont" style="color: #3D92FD" v-if="data.state == 'INIT'">待审批</span>
        <span class="ft18 boldFont" style="color: green" v-if="data.state == 'PASS'">已同意</span>
        <span class="ft18 boldFont" style="color: red" v-if="data.state == 'REJECT'">已驳回</span>

        <nut-ellipsis class="mt12 ft14" :rows="1" :content="data.saleRecord.goodName"/>
        <span class="ft12 lightText">付款时间：{{ data.saleRecord.paidTime }}</span>
        <span class="ft12 numberText">实付金额：¥{{ (data.saleRecord.amt / 100).toFixed(2) }}</span>
        <span class="ft12 mt12">退款申请人：{{ data.creatorName }}</span>
        <span class="ft12">退款申请时间：{{ data.createdTime }}</span>
        <span class="ft12 numberText">退款申请金额：¥{{ (data.refundAmt / 100).toFixed(2) }}</span>
        <span class="ft12">退款申请理由：{{ data.reason }}</span>
        <template v-if="data.state != 'INIT'">
          <span class="ft12 mt12">审核人：{{ data.auditorName }}</span>
          <span class="ft12">审核备注：{{ data.remark }}</span>
          <span class="ft12">审核时间：{{ data.updatedTime }}</span>
        </template>
      </nut-col>
    </nut-row>
    <nut-row class="mt18" v-if="data.state == 'INIT'">
      <nut-input placeholder="可选填同意/不同意原因" label="备注" v-model="audit.remark"></nut-input>
      <nut-row class="bothCenter mt16">
        <nut-col :span="12" class="bothCenter">
          <nut-button type="danger" style="width: 80%" class="wd100 mt16" @click="passRefund">同意退款</nut-button>
        </nut-col>
        <nut-col :span="12" class="bothCenter">
          <nut-button class="wd100 mt16" style="width: 80%" @click="rejectRefund">拒绝退款</nut-button>
        </nut-col>
      </nut-row>
    </nut-row>
  </div>
</template>

<script>
import api from "@/api";
import {Toast} from "@nutui/nutui";

export default {
  name: "RefundOrderCard",
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      passCnt: 0,
      rejectCnt: 0,
      audit: {
        remark: null,
      },
    }
  },
  methods: {
    passRefund() {
      this.audit.id = this.data.saleRecord.id;
      this.audit.result = true;
      Toast.loading('请稍等...')
      api.auditRefund(this.audit)
          .then(() => {
            this.$emit('fresh')
          }).finally(() => {
        Toast.hide()
      })
    },
    rejectRefund() {
      this.audit.id = this.data.saleRecord.id;
      this.audit.result = false;
      api.auditRefund(this.audit)
          .then(() => {
            this.$emit('fresh')
          })
    },
    init() {

    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.RefundOrderCardContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 16px;

  .receiveBtn {
    padding: 4px 10px;
    border: 1px solid #E76A2C;
    border-radius: 14px;
    background: white;
    color: #E76A2C;
  }

  .delText {
    text-decoration: line-through;
  }
}
</style>